import React, { lazy, Suspense } from 'react';
import { useState, useEffect, } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, } from 'reactstrap';
import { IsShowFreightAndShearingCostFields, loggedInUserId, userDepartmetList } from "../../../../helper/auth"
import { defaultPageSize, EMPTY_DATA, ENTRY_TYPE_DOMESTIC, ENTRY_TYPE_IMPORT, FILE_URL } from '../../../../config/constants';
import NoContentFound from '../../../common/NoContentFound';
import { MESSAGES } from '../../../../config/message';
import Toaster from '../../../common/Toaster';
import 'react-input-range/lib/css/index.css'
import DayTime from '../../../common/DayTimeWrapper'
import LoaderCustom from '../../../common/LoaderCustom';
import { FORGING, RMDOMESTIC_DOWNLOAD_EXCEl } from '../../../../config/masterData';
import { RM_MASTER_ID, APPROVAL_ID, RmDomestic } from '../../../../config/constants'
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import ReactExport from 'react-export-excel';
import { CheckApprovalApplicableMaster, getConfigurationKey, searchNocontentFilter, setLoremIpsum } from '../../../../helper';
import PopupMsgWrapper from '../../../common/PopupMsgWrapper';
import { editRMIndexedSimulationData, getListingForSimulationCombined, getRMIndexationCostingSimulationListing, getRMIndexationSimulationListing, setSelectedRowForPagination } from '../../../simulation/actions/Simulation';
import WarningMessage from '../../../common/WarningMessage';
import _ from 'lodash';
import { reactLocalStorage } from 'reactjs-localstorage';
import { checkMasterCreateByCostingPermission, hideCustomerFromExcel, hideMultipleColumnFromExcel } from '../../../common/CommonFunctions';
import Attachament from '../../../costing/components/Drawers/Attachament';
import Button from '../../../layout/Button';
import PaginationControls from '../../../common/Pagination/PaginationControls';
import { PaginationWrappers } from '../../../common/Pagination/PaginationWrappers';
import { resetStatePagination, updateCurrentRowIndex, updateGlobalTake, updatePageNumber, updatePageSize } from '../../../common/Pagination/paginationAction';
import TourWrapper from '../../../common/Tour/TourWrapper';
import { Steps } from '../../../common/Tour/TourMessages';
import { useTranslation } from 'react-i18next';
import { disabledClass } from '../../../../actions/Common';
import { RMDOMESTIC } from '../../../../config/constants';
import { deleteRawMaterialAPI, getAllrmIndexationSimulationList } from '../../../masters/actions/Material';
import AnalyticsDrawer from '../../../masters/material-master/AnalyticsDrawer';
import CustomCellRenderer from '../../../rfq/CommonDropdown';
import { useLabels, useWithLocalization } from '../../../../helper/core';
import RMIndexationSimulation from './RMIndexationSimulation';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

function RMIndexationSimulationListing(props) {

    const { AddAccessibility, BulkUploadAccessibility, ViewRMAccessibility, EditAccessibility, DeleteAccessibility, DownloadAccessibility, isSimulation, apply, selectionForListingMasterAPI, objectForMultipleSimulation, master } = props;
    const [value, setvalue] = useState({ min: 0, max: 0 });
    const [isBulkUpload, setisBulkUpload] = useState(false);
    const [gridApi, setgridApi] = useState(null);                      // DONT DELETE THIS STATE , IT IS USED BY AG GRID
    const [gridColumnApi, setgridColumnApi] = useState(null);          // DONT DELETE THIS STATE , IT IS USED BY AG GRID
    const [loader, setloader] = useState(false);
    const dispatch = useDispatch();
    const allrmIndexationSimulationList = useSelector((state) => state.material.allrmIndexationSimulationList);
    const filteredRMData = useSelector((state) => state.material.filteredRMData);
    const { selectedRowForPagination, tokenForSimulation } = useSelector((state => state.simulation))
    const { globalTakes } = useSelector((state) => state.pagination);
    const rmIndexationSimulationList = useSelector((state) => state.simulation.rmIndexationSimulationList);
    const rmIndexationCostingSimulationList = useSelector((state) => state.simulation.rmIndexationCostingSimulationList);
    const [showPopup, setShowPopup] = useState(false)
    const [deletedId, setDeletedId] = useState('')
    const [showPopupBulk, setShowPopupBulk] = useState(false)
    const [disableFilter, setDisableFilter] = useState(true) // STATE MADE FOR CHECKBOX IN SIMULATION
    const [disableDownload, setDisableDownload] = useState(false)
    const [analyticsDrawer, setAnalyticsDrawer] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState([]);
    //STATES BELOW ARE MADE FOR PAGINATION PURPOSE
    const [warningMessage, setWarningMessage] = useState(false)
    // const [globalTake, setGlobalTake] = useState(defaultPageSize)
    const [filterModel, setFilterModel] = useState({});
    // const [pageNo, setPageNo] = useState(1)
    const [pageNoNew, setPageNoNew] = useState(1)
    const [totalRecordCount, setTotalRecordCount] = useState(0)
    const [isFilterButtonClicked, setIsFilterButtonClicked] = useState(false)
    // const [currentRowIndex, setCurrentRowIndex] = useState(defaultPageSize)
    const [noData, setNoData] = useState(false)
    const [dataCount, setDataCount] = useState(0)
    const [inRangeDate, setinRangeDate] = useState([])
    // const [pageSize, setPageSize] = useState({ pageSize10: true, pageSize50: false, pageSize100: false })
    const [floatingFilterData, setFloatingFilterData] = useState({ CostingHead: "", TechnologyName: "", RawMaterialName: "", RawMaterialGradeName: "", RawMaterialSpecificationName: "", RawMaterialCode: "", Category: "", MaterialType: "", DestinationPlantName: "", UnitOfMeasurementName: "", VendorName: "", BasicRatePerUOM: "", ScrapRate: "", RMFreightCost: "", RMShearingCost: "", NetLandedCost: "", EffectiveDate: "", DepartmentName: isSimulation && getConfigurationKey().IsCompanyConfigureOnPlant ? userDepartmetList() : "", NetConditionCost: "", NetCostWithoutConditionCost: "", MachiningScrapRate: "", IsScrapUOMApply: "", ScrapUnitOfMeasurement: "", CalculatedFactor: "", ScrapRatePerScrapUOM: "" })
    const [attachment, setAttachment] = useState(false);
    const [viewAttachment, setViewAttachment] = useState([])
    const [showExtraData, setShowExtraData] = useState(false)
    const [render, setRender] = useState(false)
    const [editSelectedList, setEditSelectedList] = useState(false)
    const [tempList, setTempList] = useState([])
    const { t } = useTranslation("common")
    const { technologyLabel, vendorLabel } = useLabels();

    var filterParams = {
        date: "", inRangeInclusive: true, filterOptions: ['equals', 'inRange'],
        comparator: function (filterLocalDateAtMidnight, cellValue) {
            var dateAsString = cellValue != null ? DayTime(cellValue).format('DD/MM/YYYY') : '';
            var newDate = filterLocalDateAtMidnight != null ? DayTime(filterLocalDateAtMidnight).format('DD/MM/YYYY') : '';
            handleDate(newDate)// FOR COSTING BENCHMARK BOP REPORT
            let date = document.getElementsByClassName('ag-input-field-input')
            for (let i = 0; i < date.length; i++) {
                if (date[i].type == 'radio') {
                    date[i].click()
                }
            }

            setDate(newDate)
            if (dateAsString == null) return -1;
            var dateParts = dateAsString.split('/');
            var cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            }
        },

        browserDatePicker: true,
        minValidYear: 2000,

    };
    useEffect(() => {
        if (rmIndexationSimulationList?.length > 0) {
            setTotalRecordCount(rmIndexationSimulationList[0].TotalRecordCount)
        }
        else {
            setNoData(false)
        }

    }, [rmIndexationSimulationList])

    useEffect(() => {
        if (!props.stopApiCallOnCancel) {
            if (isSimulation && selectionForListingMasterAPI === 'Combined') {
                props?.changeSetLoader(true)
                dispatch(getListingForSimulationCombined(objectForMultipleSimulation, RMDOMESTIC, (res) => {
                    props?.changeSetLoader(false)
                    setloader(false)
                }))
            } else {
                if (isSimulation && !props?.isFromVerifyPage) {
                    props?.changeTokenCheckBox(false)
                }
                getDataList(floatingFilterData, 0, defaultPageSize, true)
            }
            setvalue({ min: 0, max: 0 });
        }
        // dispatch(editRMIndexedSimulationData(props.rawMaterialIds, (res) => {
        //     

        // }))
    }, [])


    useEffect(() => {
        reactLocalStorage.setObject('selectedRow', {})
        if (!props.stopApiCallOnCancel) {
            return () => {
                dispatch(setSelectedRowForPagination([]))
                dispatch(resetStatePagination());

                reactLocalStorage.setObject('selectedRow', {})
            }
        }
    }, [])
    const apiResponse = (res, isPagination,) => {
        if (isSimulation && !props?.isFromVerifyPage) {
            props?.changeTokenCheckBox(true)
        }
        if (res && res.status === 200) {
            setloader(false);

        } else if (res && res.response && res.response.status === 412) {
            setloader(false);

        } else {
            setloader(false);
        }

        if (res && isPagination === false) {
            setDisableDownload(false)
            setTimeout(() => {
                dispatch(disabledClass(false))
                let button = document.getElementById('Excel-Downloads-rm-import')
                button && button.click()
            }, 500);
        }

        if (res && res.status === 204) {
            setTotalRecordCount(0)
            dispatch(updatePageNumber(0))
            // setPageNo(0)
        }

        if (res) {
            let isReset = true
            setTimeout(() => {
                for (var prop in floatingFilterData) {

                    if (prop !== "DepartmentName" && prop !== 'RawMaterialEntryType' && floatingFilterData[prop] !== "") {
                        isReset = false
                    }

                }
                // Sets the filter model via the grid API
                isReset ? (gridOptions?.api?.setFilterModel({})) : (gridOptions?.api?.setFilterModel(filterModel))
            }, 300);

            setTimeout(() => {
                setWarningMessage(false)
            }, 330);

            setTimeout(() => {
                setIsFilterButtonClicked(false)
            }, 600);
        }
    }

    /**
    * @method hideForm
    * @description HIDE DOMESTIC, IMPORT FORMS
    */
    const getDataList = (dataObj, skip = 0, take = 10, isPagination = true, isReset = false) => {

        if (filterModel?.EffectiveDate && !isReset) {

            if (filterModel.EffectiveDate.dateTo) {
                let temp = []
                temp.push(DayTime(filterModel.EffectiveDate.dateFrom).format('DD/MM/YYYY'))
                temp.push(DayTime(filterModel.EffectiveDate.dateTo).format('DD/MM/YYYY'))

                dataObj.dateArray = temp
            }
        }

        // TO HANDLE FUTURE CONDITIONS LIKE [APPROVED_STATUS, DRAFT_STATUS] FOR MULTIPLE STATUS
        let statusString = [props?.approvalStatus].join(",")
        const filterData = {
            // costingHead: isSimulation && filteredRMData && filteredRMData.costingHeadTemp ? filteredRMData.costingHeadTemp.value : costingHead,
            // plantId: isSimulation && filteredRMData && filteredRMData.plantId ? filteredRMData.plantId.value : plantId,
            // material_id: isSimulation && filteredRMData && filteredRMData.RMid ? filteredRMData.RMid.value : materialId,
            // grade_id: isSimulation && filteredRMData && filteredRMData.RMGradeid ? filteredRMData.RMGradeid.value : gradeId,
            // vendor_id: isSimulation && filteredRMData && filteredRMData.Vendorid ? filteredRMData.Vendorid.value : vendorId,
            technology_id: props.isCostingSimulation ? Number(props.technology) : '',
            // net_landed_min_range: value.min,
            // net_landed_max_range: value.max,
            // departmentCode: isSimulation ? userDepartmetList() : "",
            // statusId: CheckApprovalApplicableMaster(RM_MASTER_ID) ? APPROVAL_ID : 0,
            // ListFor: ListFor,
            // StatusId: statusString,
            isIndexationDetails: props?.type?.label === "Indexed" ? true : false,
            Currency: isSimulation && props?.fromListData && props?.fromListData ? props?.fromListData : '',
            LocalCurrency: isSimulation && props?.toListData && props?.toListData ? props?.toListData : '',
            EffectiveDate: props?.minDate ? props?.minDate : '',
            ListFor: props?.ListFor ? props?.ListFor : '',
            vendorId: props?.vendorLabel?.value,


        }
        //THIS CONDTION IS FOR IF THIS COMPONENT IS RENDER FROM MASTER APPROVAL SUMMARY IN THIS NO GET API
        if (isPagination === true) {
            setloader(true)
        }
        if (String(master) === RMDOMESTIC) {
            filterData.RawMaterialEntryType = Number(ENTRY_TYPE_DOMESTIC)
            dispatch(getRMIndexationCostingSimulationListing(filterData, skip, take, isPagination, (res) => {
                apiResponse(res, isPagination)
                if (props.isSimulation) {
                    props.getmasterListing(res?.data?.DataList)
                }
            }))
        } else {

            filterData.RawMaterialEntryType = props?.FromExchangeRate ? Number(ENTRY_TYPE_IMPORT) : null
            dispatch(getRMIndexationSimulationListing(filterData, skip, take, isPagination, (res) => {
                // apply(selectedRowForPagination, selectedRowForPagination.length)
                apiResponse(res, isPagination)
            }))
        }

    }
    var setDate = (date) => {
        setFloatingFilterData((prevState) => ({ ...prevState, EffectiveDate: date }));
    };

    var handleDate = (newDate) => {
        let temp = inRangeDate
        temp.push(newDate)
        setinRangeDate(temp)        // setState((prevState) => ({ ...prevState, inRangeDate: temp }))
        if (props?.benchMark) {
            props?.handleDate(inRangeDate)
        }
        setTimeout(() => {
            var y = document.getElementsByClassName('ag-radio-button-input');
            var radioBtn = y[0];
            radioBtn?.click()

        }, 300);
    }

    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (rmIndexationSimulationList.length !== 0) {
                setNoData(searchNocontentFilter(value, noData))
            }
        }, 500);
        setDisableFilter(false)
        const model = gridOptions?.api?.getFilterModel();
        setFilterModel(model)
        if (!isFilterButtonClicked) {
            setWarningMessage(true)
        }

        if (value?.filterInstance?.appliedModel === null || value?.filterInstance?.appliedModel?.filter === "") {
            let isFilterEmpty = true
            if (model !== undefined && model !== null) {
                if (Object.keys(model).length > 0) {
                    isFilterEmpty = false

                    for (var property in floatingFilterData) {

                        if (property === value.column.colId) {
                            floatingFilterData[property] = ""
                        }
                    }
                    setFloatingFilterData(floatingFilterData)
                }

                if (isFilterEmpty) {
                    setWarningMessage(false)
                    for (var prop in floatingFilterData) {

                        if (isSimulation && getConfigurationKey().IsCompanyConfigureOnPlant) {
                            if (prop !== "DepartmentName") {
                                floatingFilterData[prop] = ""
                            }

                        } else {
                            floatingFilterData[prop] = ""
                        }
                    }
                    setFloatingFilterData(floatingFilterData)
                }
            }

        } else {

            if (value.column.colId === "EffectiveDate" || value.column.colId === "CreatedDate") {
                return false
            }
            setFloatingFilterData({ ...floatingFilterData, [value.column.colId]: value.filterInstance.appliedModel.filter })
        }

    }

    /**
        * @method toggleExtraData
        * @description Handle specific module tour state to display lorem data
        */
    const toggleExtraData = (showTour) => {

        setRender(true)
        setTimeout(() => {
            setShowExtraData(showTour)
            setRender(false)
        }, 100);


    }
    const onSearch = () => {
        setNoData(false)
        setWarningMessage(false)
        setIsFilterButtonClicked(true)
        // setPageNo(1)
        dispatch(updatePageNumber(1))
        setPageNoNew(1)
        dispatch(updateCurrentRowIndex(10))
        // setCurrentRowIndex(0)
        gridOptions?.columnApi?.resetColumnState();
        getDataList(floatingFilterData, 0, globalTakes, true, true)
    }



    const resetState = () => {
        setNoData(false)
        setinRangeDate([])
        setIsFilterButtonClicked(false)
        gridOptions?.columnApi?.resetColumnState(null);
        gridOptions?.api?.setFilterModel(null);

        for (var prop in floatingFilterData) {

            if (isSimulation && getConfigurationKey().IsCompanyConfigureOnPlant) {
                if (prop !== "DepartmentName") {
                    floatingFilterData[prop] = ""
                }
            } else {
                floatingFilterData[prop] = ""
            }
        }

        setFloatingFilterData(floatingFilterData)
        setWarningMessage(false)
        dispatch(updatePageNumber(1))
        setPageNoNew(1)
        dispatch(updateCurrentRowIndex(10))
        getDataList(floatingFilterData, 0, 10, true, true)
        dispatch(setSelectedRowForPagination([]))
        dispatch(updateGlobalTake(10))
        dispatch(updatePageSize({ pageSize10: true, pageSize50: false, pageSize100: false }))
        setDataCount(0)
        reactLocalStorage.setObject('selectedRow', {})
        if (isSimulation) {
            props.isReset()
        }
    }

    /**
    * @method viewOrEditItemDetails
    * @description edit or view material type
    */
    const viewOrEditItemDetails = (Id, rowData = {}, isViewMode) => {

        let data = {
            isEditFlag: true,
            isViewFlag: isViewMode,
            costingTypeId: rowData.CostingTypeId,
            Id: Id,
            IsVendor: rowData.CostingHead === 'Vendor Based' ? true : rowData.CostingHead === 'Zero Based' ? false : rowData.CostingHead,
        }
        props.getDetails(data, rowData?.IsRMAssociated);
    }

    /**
    * @method deleteItem
    * @description confirm delete Raw Material details
    */
    const deleteItem = (Id) => {
        setShowPopup(true)
        setDeletedId(Id)
    }

    /**
    * @method confirmDelete
    * @description confirm delete Raw Material details
    */
    const confirmDelete = (ID) => {
        const loggedInUser = loggedInUserId()
        dispatch(deleteRawMaterialAPI(ID, loggedInUser, (res) => {
            if (res !== undefined && res.status === 417 && res.data.Result === false) {
                Toaster.error(res.data.Message)
            } else if (res && res.data && res.data.Result === true) {
                Toaster.success(MESSAGES.DELETE_RAW_MATERIAL_SUCCESS);
                setDataCount(0)
                resetState()
            }
        }));
        setShowPopup(false)
    }

    const onPopupConfirm = () => {
        confirmDelete(deletedId);
    }
    const onPopupConfirmBulk = () => {
        confirmDensity()
    }
    const closePopUp = () => {
        setShowPopup(false)
        setShowPopupBulk(false)
    }
    const cancel = () => {
        props?.cancelImportList();
    };
    const editSelectedData = () => {
        setTempList(gridApi?.getSelectedRows())
        setEditSelectedList(true)
    };
    const backToSimulation = (value) => {
        setEditSelectedList(false)
    };
    /**
    * @method buttonFormatter
    * @description Renders buttons
    */
    const { benchMark } = props

    const buttonFormatter = (props) => {
        const cellValue = props?.valueFormatted ? props.valueFormatted : props?.value;
        const rowData = props?.valueFormatted ? props.valueFormatted : props?.data;
        let isEditbale = false
        let isDeleteButton = false
        if (EditAccessibility) {
            isEditbale = true
        } else {
            isEditbale = false
        }
        if (showExtraData && props.rowIndex === 0) {
            isDeleteButton = true
        } else {
            if (DeleteAccessibility && !rowData.IsRMAssociated) {
                isDeleteButton = true
            }
        }

        return (
            <>

                <Button
                    id={`rmDomesticListing_movement${props.rowIndex}`}
                    className={"mr-1 Tour_List_Cost_Movement"}
                    variant="cost-movement"
                    onClick={() => showAnalytics(cellValue, rowData)}
                    title={"Cost Movement"}
                />

                {(!benchMark) && (
                    <>
                        {ViewRMAccessibility && <Button
                            id={`rmDomesticListing_view${props.rowIndex}`}
                            className={"mr-1 Tour_List_View"}
                            variant="View"
                            onClick={() => viewOrEditItemDetails(cellValue, rowData, true)}
                            title={"View"}
                        />}
                        {isEditbale && <Button
                            id={`rmDomesticListing_edit${props.rowIndex}`}
                            className={"mr-1 Tour_List_Edit"}
                            variant="Edit"
                            onClick={() => viewOrEditItemDetails(cellValue, rowData, false)}
                            title={"Edit"}
                        />}
                        {isDeleteButton && <Button
                            id={`rmDomesticListing_delete${props.rowIndex}`}
                            className={"mr-1 Tour_List_Delete"}
                            variant="Delete"
                            onClick={() => deleteItem(cellValue)}
                            title={"Delete"}
                        />}
                    </>
                )}
            </>
        )
    };

    /**
    * @method costingHeadFormatter
    * @description Renders Costing head
    */
    const costingHeadFormatter = (props) => {
        const cellValue = props?.valueFormatted ? props.valueFormatted : props?.value;

        let data = (cellValue === true || cellValue === 'Vendor Based' || cellValue === 'VBC') ? 'Vendor Based' : 'Zero Based';

        return data;
    }


    const costFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        let value = cell != null ? cell : '-';
        return value
    }

    /**
    * @method effectiveDateFormatter
    * @description Renders buttons
    */
    const effectiveDateFormatter = (props) => {
        if (showExtraData && props?.rowIndex === 0) {
            return "Lorem Ipsum";
        } else {
            const cellValue = props?.valueFormatted ? props.valueFormatted : props?.value;
            return cellValue != null ? DayTime(cellValue).format('DD/MM/YYYY') : '';
        }
    }

    /**
    * @method hyphenFormatter
    */
    const hyphenFormatter = (props) => {
        const cellValue = props?.value;
        return (cellValue !== ' ' && cellValue !== null && cellValue !== '' && cellValue !== undefined) ? cellValue : '-';
    }

    const statusFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        // CHANGE IN STATUS IN AFTER KAMAL SIR API
        return <div className={row.Status}>{row.DisplayStatus}</div>
    }



    /**
    * @method commonCostFormatter
    * @description Renders buttons
    */
    const commonCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell != null ? cell : '-';
    }


    const formToggle = () => {
        if (checkMasterCreateByCostingPermission()) {
            props.formToggle()
        }
    }

    const bulkToggle = () => {
        if (checkMasterCreateByCostingPermission(true)) {
            setisBulkUpload(true);
        }
    }

    const closeBulkUploadDrawer = (event, type) => {
        setisBulkUpload(false);
        if (type !== 'cancel') {
            resetState()
        }
    }

    /**
    * @method densityAlert
    * @description confirm Redirection to Material tab.
    */
    const densityAlert = () => {
    }


    /**
    * @method confirmDensity
    * @description confirm density popup.
    */
    const confirmDensity = () => {
        props.toggle('4')
    }


    const onGridReady = (params) => {
        setgridApi(params.api);

        setgridColumnApi(params.columnApi);
        params.api.paginationGoToPage(0);
        const checkBoxInstance = document.querySelectorAll('.ag-input-field-input.ag-checkbox-input');
        checkBoxInstance.forEach((checkBox, index) => {
            const specificId = `RM_Domestic_Checkbox${index / 11}`;
            checkBox.id = specificId;
        })
        const floatingFilterInstances = document.querySelectorAll('.ag-input-field-input.ag-text-field-input');
        floatingFilterInstances.forEach((floatingFilter, index) => {
            const specificId = `RM_Domestic_Floating${index}`;
            floatingFilter.id = specificId;
        });
    };



    const returnExcelColumn = (data = [], TempData) => {
        let excelData = hideCustomerFromExcel(data, "CustomerName")

        if (!getConfigurationKey().IsBasicRateAndCostingConditionVisible) {
            excelData = hideMultipleColumnFromExcel(excelData, ["NetConditionCost", "NetCostWithoutConditionCost"])
        }
        let temp = []
        temp = TempData && TempData.map((item) => {
            if (item.CostingHead === true) {
                item.CostingHead = 'Vendor Based'
                item.EffectiveDate = (item.EffectiveDate)?.slice(0, 10)

            } else if (item.CostingHead === false) {
                item.CostingHead = 'Zero Based'
                item.EffectiveDate = (item.EffectiveDate)?.slice(0, 10)

            } else {
                item.EffectiveDate = (item.EffectiveDate)?.slice(0, 10)

            }
            return item
        })

        return (

            <ExcelSheet data={temp} name={RmDomestic}>
                {excelData && excelData.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
            </ExcelSheet>);
    }



    const onExcelDownload = () => {
        setDisableDownload(true)
        dispatch(disabledClass(true))
        //let tempArr = gridApi && gridApi?.getSelectedRows()
        let tempArr = selectedRowForPagination
        if (tempArr?.length > 0) {
            setTimeout(() => {
                setDisableDownload(false)
                dispatch(disabledClass(false))
                let button = document.getElementById('Excel-Downloads-rm-import')
                button && button.click()
            }, 400);


        } else {

            getDataList(floatingFilterData, 0, defaultPageSize, false) // FOR EXCEL DOWNLOAD OF COMPLETE DATA
        }

    }
    const RMDOMESTIC_DOWNLOAD_EXCEl_LOCALIZATION = useWithLocalization(RMDOMESTIC_DOWNLOAD_EXCEl, "MasterLabels")
    const onBtExport = () => {
        let tempArr = []
        //tempArr = gridApi && gridApi?.getSelectedRows()
        tempArr = selectedRowForPagination
        tempArr = (tempArr && tempArr.length > 0) ? tempArr : (allrmIndexationSimulationList ? allrmIndexationSimulationList : [])
        return returnExcelColumn(RMDOMESTIC_DOWNLOAD_EXCEl_LOCALIZATION, tempArr)
    };

    const onFilterTextBoxChanged = (e) => {
        gridApi.setQuickFilter(e.target.value);
    }


    const isFirstColumn = (params) => {

        var displayedColumns = params.columnApi.getAllDisplayedColumns();
        var thisIsFirstColumn = displayedColumns[0] === params.column;

        if (props?.isMasterSummaryDrawer) {
            return false
        } else {
            return thisIsFirstColumn;
        }

    }

    const onRowSelect = (event) => {

        let selectedRowForPagination = reactLocalStorage.getObject('selectedRow').selectedRow

        var selectedRows = gridApi && gridApi?.getSelectedRows();
        if (selectedRows === undefined || selectedRows === null) {    //CONDITION FOR FIRST RENDERING OF COMPONENT
            selectedRows = selectedRowForPagination
        } else if (selectedRowForPagination && selectedRowForPagination.length > 0) {  // CHECKING IF REDUCER HAS DATA

            let finalData = []
            if (event.node.isSelected() === false) {    // CHECKING IF CURRENT CHECKBOX IS UNSELECTED

                for (let i = 0; i < selectedRowForPagination.length; i++) {
                    if (selectedRowForPagination[i].RawMaterialId === event.data.RawMaterialId) {   // REMOVING UNSELECTED CHECKBOX DATA FROM REDUCER
                        continue;
                    }
                    finalData.push(selectedRowForPagination[i])
                }

            } else {
                finalData = selectedRowForPagination
            }
            selectedRows = [...selectedRows, ...finalData]

        }

        let uniqeArray = _.uniqBy(selectedRows, "RawMaterialId")          //UNIQBY FUNCTION IS USED TO FIND THE UNIQUE ELEMENTS & DELETE DUPLICATE ENTRY
        reactLocalStorage.setObject('selectedRow', { selectedRow: uniqeArray }) //SETTING CHECKBOX STATE DATA IN LOCAL STORAGE
        setDataCount(uniqeArray.length)
        dispatch(setSelectedRowForPagination(uniqeArray))
        let finalArr = selectedRows
        let length = finalArr?.length
        let uniqueArray = _.uniqBy(finalArr, "RawMaterialId")

        if (isSimulation && !props?.isFromVerifyPage) {
            apply(uniqueArray, length)
        }

        if (props?.benchMark) {
            let uniqueArrayNew = _.uniqBy(selectedRows, v => [v.TechnologyId, v.RawMaterial].join())

            if (uniqueArrayNew.length > 1) {
                dispatch(setSelectedRowForPagination([]))
                gridApi.deselectAll()
                Toaster.warning(`${technologyLabel} & Raw material should be same`)
            }
        }
    }

    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        headerCheckboxSelection: (isSimulation || props?.benchMark) ? isFirstColumn : false,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: isFirstColumn
    };

    const checkBoxRenderer = (props) => {
        let selectedRowForPagination = reactLocalStorage.getObject('selectedRow').selectedRow
        const cellValue = props?.valueFormatted ? props.valueFormatted : props?.value;
        if (selectedRowForPagination?.length > 0) {
            selectedRowForPagination.map((item) => {
                if (item.RawMaterialId === props.node.data.RawMaterialId) {
                    props.node.setSelected(true)
                }
                return null
            })
            return cellValue
        } else {
            return cellValue
        }
    }

    const closeAnalyticsDrawer = () => {
        setAnalyticsDrawer(false)
    }

    const showAnalytics = (cell, rowData) => {
        setSelectedRowData(rowData)
        setAnalyticsDrawer(true)
    }
    const viewAttachmentData = (index) => {
        setAttachment(true)
        setViewAttachment(index)
    }
    const closeAttachmentDrawer = (e = '') => {
        setAttachment(false)
    }
    const attachmentFormatter = (props) => {
        const row = props?.data;
        let files = row?.Attachements
        if (files && files?.length === 0) {
            return '-'
        }
        return (
            <>
                <div className={"attachment images"}>
                    {files && files.length === 1 ?
                        files.map((f) => {
                            const withOutTild = f.FileURL?.replace("~", "");
                            const fileURL = `${FILE_URL}${withOutTild}`;
                            return (
                                <a href={fileURL} target="_blank" rel="noreferrer">
                                    {f.OriginalFileName}
                                </a>
                            )

                        }) :


                        <Button
                            id={`rmDomesticListing_attachment${props.rowIndex}`}
                            className={"mr5"}
                            variant="btn-a"
                            onClick={() => viewAttachmentData(row)}
                            title={"View Attachment"}
                        >View Attachment</Button>}

                </div >
            </>
        )

    }
    const frameworkComponents = {
        totalValueRenderer: buttonFormatter,
        effectiveDateRenderer: effectiveDateFormatter,
        costingHeadRenderer: costingHeadFormatter,
        customNoRowsOverlay: NoContentFound,
        costFormatter: costFormatter,
        commonCostFormatter: commonCostFormatter,
        statusFormatter: statusFormatter,
        hyphenFormatter: hyphenFormatter,
        checkBoxRenderer: checkBoxRenderer,
        attachmentFormatter: attachmentFormatter,

    }
    return (
        <div>
            {!editSelectedList && (
                <div className={`ag-grid-react ${(props?.isMasterSummaryDrawer === undefined || props?.isMasterSummaryDrawer === false) ? "custom-pagination" : ""} ${DownloadAccessibility ? "show-table-btn" : ""} ${isSimulation ? 'simulation-height' : props?.isMasterSummaryDrawer ? '' : 'min-height100vh'}`}>
                    {(loader && !props.isMasterSummaryDrawer) ? <LoaderCustom customClass="simulation-Loader" /> :
                        <>
                            {disableDownload && <LoaderCustom message={MESSAGES.DOWNLOADING_MESSAGE} />}
                            <Row className={`filter-row-large ${props?.isSimulation ? 'zindex-0 ' : ''} ${props?.isMasterSummaryDrawer ? '' : 'pt-2'}`}>
                                <Col md="3" lg="3" className='mb-2'>
                                    <input type="text" className="form-control table-search" id="filter-text-box" placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                    {(!props.isSimulation && !props.benchMark && !props?.isMasterSummaryDrawer) && (<TourWrapper
                                        buttonSpecificProp={{
                                            id: "RMDomestic_Listing_Tour", onClick: toggleExtraData
                                        }}
                                        stepsSpecificProp={{
                                            steps: Steps(t, { addLimit: false, copyButton: false, viewBOM: false, status: false, updateAssociatedTechnology: false, addMaterial: false, addAssociation: false, generateReport: false, approve: false, reject: false }).COMMON_LISTING
                                        }} />)}
                                </Col>
                                <Col md="9" lg="9" className="mb-3 d-flex justify-content-end">
                                    {
                                        // SHOW FILTER BUTTON ONLY FOR RM MASTER NOT FOR SIMULATION AMD MASTER APPROVAL SUMMARY
                                        (!props.isMasterSummaryDrawer) &&
                                        <>
                                            {isSimulation &&

                                                <div className="warning-message d-flex align-items-center">
                                                    {warningMessage && !disableDownload && <><WarningMessage dClass="mr-3" message={'Please click on filter button to filter all data'} /><div className='right-hand-arrow mr-2'></div></>}

                                                    <Button
                                                        id="rmDomesticListing_filter"
                                                        className={"mr5 Tour_List_Filter"}
                                                        onClick={() => onSearch()}
                                                        title={"Filtered data"}
                                                        icon={"filter"}
                                                        disabled={disableFilter}
                                                    />
                                                </div>
                                            }
                                            {!isSimulation &&
                                                <div className="d-flex justify-content-end bd-highlight w100">

                                                    <>
                                                        {(props?.isMasterSummaryDrawer === undefined || this.props?.isMasterSummaryDrawer === false) &&
                                                            <div className="warning-message d-flex align-items-center">
                                                                {warningMessage && !disableDownload && <><WarningMessage dClass="mr-3" message={'Please click on filter button to filter all data'} /><div className='right-hand-arrow mr-2'></div></>}
                                                            </div>
                                                        }
                                                        {(props?.isMasterSummaryDrawer === undefined || this.props?.isMasterSummaryDrawer === false) &&

                                                            <Button
                                                                id="rmDomesticListing_filter"
                                                                className={"mr5 Tour_List_Filter"}
                                                                onClick={() => onSearch()}
                                                                title={"Filtered data"}
                                                                icon={"filter"}
                                                                disabled={disableFilter}
                                                            />
                                                        }

                                                        {AddAccessibility && (
                                                            <Button
                                                                id="rmDomesticListing_add"
                                                                className={"mr5 Tour_List_Add"}
                                                                onClick={formToggle}
                                                                title={"Add"}
                                                                icon={"plus"}
                                                            />
                                                        )}
                                                        {BulkUploadAccessibility && (
                                                            <Button
                                                                id="rmDomesticListing_add"
                                                                className={"mr5 Tour_List_BulkUpload"}
                                                                onClick={bulkToggle}
                                                                title={"Bulk Upload"}
                                                                icon={"upload"}
                                                            />
                                                        )}
                                                        {
                                                            DownloadAccessibility &&
                                                            <>

                                                                <Button
                                                                    className="mr5 Tour_List_Download"
                                                                    id={"rmDomesticListing_excel_download"}
                                                                    onClick={onExcelDownload}
                                                                    title={`Download ${dataCount === 0 ? "All" : "(" + dataCount + ")"}`}
                                                                    icon={"download mr-1"}
                                                                    buttonName={`${dataCount === 0 ? "All" : "(" + dataCount + ")"}`}
                                                                />
                                                                <ExcelFile filename={'RM Domestic'} fileExtension={'.xls'} element={
                                                                    <Button id={"Excel-Downloads-rm-import"} className="p-absolute" />

                                                                }>
                                                                    {onBtExport()}
                                                                </ExcelFile>
                                                            </>
                                                        }

                                                    </>
                                                </div>
                                            }


                                        </>

                                    }
                                    <Button
                                        id={"rmDomesticListing_refresh"}
                                        className={"Tour_List_Reset mr-1"}
                                        onClick={() => resetState()}
                                        title={"Reset Grid"}
                                        icon={"refresh"}
                                    />
                                    {props.isSimulation && props.isFromVerifyPage && (
                                        <button type="button" className={"apply"} onClick={cancel}                        >
                                            <div className={"back-icon"}></div>Back
                                        </button>
                                    )}
                                </Col>

                            </Row>
                            <Row>

                                <Col>
                                    <div className={`ag-grid-wrapper ${(props?.isDataInMaster && !noData) ? 'master-approval-overlay' : ''} ${(rmIndexationSimulationList && rmIndexationSimulationList?.length <= 0) || noData ? 'overlay-contain' : ''}`}>
                                        <div className={`ag-theme-material `}>
                                            {noData && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found" />}
                                            {render ? <LoaderCustom customClass="loader-center" /> : <AgGridReact
                                                style={{ height: '100%', width: '100%' }}
                                                defaultColDef={defaultColDef}
                                                floatingFilter={true}
                                                domLayout='autoHeight'
                                                rowData={props.isCostingSimulation ? rmIndexationCostingSimulationList : rmIndexationSimulationList}

                                                pagination={true}
                                                paginationPageSize={globalTakes}
                                                onGridReady={onGridReady}
                                                gridOptions={gridOptions}
                                                noRowsOverlayComponent={'customNoRowsOverlay'}
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                    imagClass: 'imagClass'
                                                }}
                                                frameworkComponents={frameworkComponents}
                                                rowSelection={'multiple'}
                                                onRowSelected={onRowSelect}
                                                onFilterModified={onFloatingFilterChanged}
                                                suppressRowClickSelection={true}
                                                enableBrowserTooltips={true}
                                            >
                                                <AgGridColumn cellClass="has-checkbox" field="CostingHead" headerName='Costing Head' cellRenderer={checkBoxRenderer}></AgGridColumn>
                                                <AgGridColumn field="EntryType" headerName="Entry Type" cellRenderer={"hyphenFormatter"}></AgGridColumn>
                                                <AgGridColumn field={props.isCostingSimulation ? 'Technology' : 'TechnologyName'} headerName={technologyLabel}></AgGridColumn>
                                                <AgGridColumn field="RawMaterialName" headerName='Raw Material'></AgGridColumn>
                                                <AgGridColumn field={props.isCostingSimulation ? 'RawMaterialGrade' : "RawMaterialGradeName"} headerName="Grade"></AgGridColumn>
                                                <AgGridColumn field={props.isCostingSimulation ? 'RawMaterialSpecs' : "RawMaterialSpecificationName"} headerName="Spec"></AgGridColumn>
                                                <AgGridColumn field="RawMaterialCode" headerName='Code' cellRenderer='hyphenFormatter'></AgGridColumn>
                                                <AgGridColumn field="Category"></AgGridColumn>
                                                <AgGridColumn field="MaterialType"></AgGridColumn>
                                                {getConfigurationKey()?.IsShowSourceVendorInRawMaterial && !props.isCostingSimulation && <AgGridColumn field="SourceVendorAssociatedAsRawMaterialVendors" width={250} headerName={`Raw Material Code (Source ${vendorLabel} Code)`} cellRendererFramework={CustomCellRenderer}></AgGridColumn>}
                                                {props.isCostingSimulation && <AgGridColumn field="SourceVendorName" width={250} headerName={`Source ${vendorLabel} (Code)`} cellRenderer='hyphenFormatter'></AgGridColumn>}
                                                <AgGridColumn field={props.isCostingSimulation ? 'PlantCode' : "DestinationPlantName"} headerName="Plant (Code)"></AgGridColumn>
                                                <AgGridColumn field={props.isCostingSimulation ? 'VendorCode' : "VendorName"} headerName={`${vendorLabel} (Code)`}></AgGridColumn>
                                                {/* <AgGridColumn field="DepartmentName" headerName="Department"></AgGridColumn> */}
                                                {reactLocalStorage.getObject('CostingTypePermission').cbc && <AgGridColumn field={props.isCostingSimulation ? 'CustomerCode' : "CustomerName"} headerName="Customer (Code)" cellRenderer={'hyphenFormatter'}></AgGridColumn>}
                                                <AgGridColumn field={props.isCostingSimulation ? 'UOM' : "UnitOfMeasurementName"} headerName='UOM'></AgGridColumn>
                                                {getConfigurationKey().IsSourceExchangeRateNameVisible && <AgGridColumn width={120} field="ExchangeRateSourceName" headerName="Exchange Rate Source"></AgGridColumn>}
                                                <AgGridColumn field="Currency" width={120} cellRenderer={"currencyFormatter"}></AgGridColumn>
                                                {!props.isCostingSimulation && <><AgGridColumn field="BasicRatePerUOM" headerName='Basic Rate' cellRenderer='commonCostFormatter'></AgGridColumn>
                                                    <AgGridColumn field="IsScrapUOMApply" headerName="Has different Scrap Rate UOM" cellRenderer='commonCostFormatter'></AgGridColumn>
                                                    <AgGridColumn field="ScrapUnitOfMeasurement" headerName='Scrap Rate UOM' cellRenderer='commonCostFormatter'></AgGridColumn>
                                                    <AgGridColumn field="CalculatedFactor" headerName='Calculated Factor' cellRenderer='commonCostFormatter'></AgGridColumn>
                                                    <AgGridColumn field="ScrapRatePerScrapUOM" headerName='Scrap Rate (In Scrap Rate UOM)' cellRenderer='commonCostFormatter'></AgGridColumn>
                                                    <AgGridColumn field="ScrapRate" cellRenderer='commonCostFormatter'></AgGridColumn>
                                                    {props.isMasterSummaryDrawer && rmIndexationSimulationList[0]?.TechnologyId === FORGING && <AgGridColumn width="140" field="MachiningScrapRate" headerName='Machining Scrap Rate'></AgGridColumn>}
                                                    {/* ON RE FREIGHT COST AND SHEARING COST COLUMN IS COMMENTED //RE */}
                                                    <AgGridColumn cellRenderer='costFormatter' field="NetCostWithoutConditionCost" headerName="Basic Price" ></AgGridColumn>
                                                    <AgGridColumn cellRenderer='costFormatter' field="OtherNetCost" headerName="Other Net Cost" ></AgGridColumn>
                                                    <AgGridColumn cellRenderer='costFormatter' field="NetConditionCost" headerName="Net Condition Cost" ></AgGridColumn>
                                                    <AgGridColumn field="NetLandedCost" headerName="Net Cost" cellRenderer='costFormatter'></AgGridColumn>

                                                    <AgGridColumn field="EffectiveDate" cellRenderer='effectiveDateRenderer' filter="agDateColumnFilter" filterParams={filterParams}></AgGridColumn></>}
                                                {(!isSimulation && !props.isMasterSummaryDrawer) && <AgGridColumn width={160} field="RawMaterialId" cellClass="ag-grid-action-container" pinned="right" headerName="Action" type="rightAligned" floatingFilter={false} cellRenderer={'totalValueRenderer'}></AgGridColumn>}
                                                <AgGridColumn field="VendorId" hide={true}></AgGridColumn>
                                                <AgGridColumn field="TechnologyId" hide={true}></AgGridColumn>
                                                {props.isMasterSummaryDrawer && <AgGridColumn field="Attachements" headerName='Attachments' cellRenderer='attachmentFormatter'></AgGridColumn>}
                                                {props.isMasterSummaryDrawer && <AgGridColumn field="Remark" tooltipField="Remark" ></AgGridColumn>}
                                            </AgGridReact>}
                                            <div className='button-wrapper'>
                                                {<PaginationWrappers gridApi={gridApi} totalRecordCount={totalRecordCount} getDataList={getDataList} floatingFilterData={floatingFilterData} module="RM" />}
                                                {(props?.isMasterSummaryDrawer === undefined || props?.isMasterSummaryDrawer === false) &&
                                                    <PaginationControls totalRecordCount={totalRecordCount} getDataList={getDataList} floatingFilterData={floatingFilterData} module="RM" />

                                                }

                                            </div>
                                        </div>
                                    </div>
                                    {props.isSimulation && props.isFromVerifyPage && (
                                        <Row>
                                            <Col md="12" className="d-flex justify-content-end align-items-center">
                                                <WarningMessage dClass="mr-5" message={`Please check the Raw Material that you want to edit.`} />
                                                <Button className={"apply"} id={"operationListing_editSelectedData"} disabled={gridApi?.getSelectedRows()?.length === 0} onClick={editSelectedData} icon="edit-icon" buttonName="Edit" />
                                            </Col>
                                        </Row>
                                    )}
                                </Col>
                            </Row>
                        </>
                    }

                    <Suspense fallback={<div>Loading...</div>}>
                        {/* Render the lazily loaded component */}
                        {/* <MyLazyComponent /> */}

                    </Suspense>

                    {
                        analyticsDrawer &&
                        <AnalyticsDrawer
                            isOpen={analyticsDrawer}
                            ModeId={1}
                            closeDrawer={closeAnalyticsDrawer}
                            anchor={"right"}
                            isReport={analyticsDrawer}
                            selectedRowData={selectedRowData}
                            isSimulation={true}
                            //cellValue={cellValue}
                            rowData={selectedRowData}
                        />
                    }

                    {
                        attachment && (
                            <Attachament
                                isOpen={attachment}
                                index={viewAttachment}
                                closeDrawer={closeAttachmentDrawer}
                                anchor={'right'}
                                gridListing={true}
                            />
                        )
                    }

                    {
                        showPopup && <PopupMsgWrapper isOpen={showPopup} closePopUp={closePopUp} confirmPopup={onPopupConfirm} message={`${MESSAGES.RAW_MATERIAL_DETAIL_DELETE_ALERT}`} />
                    }
                    {
                        showPopupBulk && <PopupMsgWrapper isOpen={showPopupBulk} closePopUp={closePopUp} confirmPopup={onPopupConfirmBulk} message={`Recently Created Material's Density is not created, Do you want to create?`} />
                    }

                </div >)}
            {editSelectedList && (
                <RMIndexationSimulation isOperation={true}
                    backToSimulation={backToSimulation}
                    // isbulkUpload={isbulkUpload}
                    // rowCount={rowCount}
                    list={tempList ? tempList : []}
                    // technology={technology.label}
                    // technologyId={technology.value}
                    // master={master.label}
                    tokenForMultiSimulation={
                        tokenForSimulation?.length !== 0
                            ? [{ SimulationId: tokenForSimulation?.value }]
                            : []
                    }
                    isRMNonIndexSimulation={true}
                    ListFor={props?.ListFor}
                    effectiveDate={props?.effectiveDate}
                    isEffectiveDateSelected={props?.isEffectiveDateSelected}
                    minDate={props?.minDate}
                    masterId={props?.FromExchangeRate ? props?.masterId : master?.value}
                />
            )}
        </div>
    );
}

export default RMIndexationSimulationListing;

